<template>
  <div>
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="title-h3">
        수집 서버 설정
      </div>
      <div>
        <el-button size="mini" type="primary" @click="saveLogCollector" :disabled="isChange">저장</el-button>
        <el-button class="cmp-margin-left" size="mini" @click="resetLogCollector" :disabled="isChange">취소</el-button>
      </div>
    </el-row>
    <el-row class="gray-box mr-b30">
      <el-col :span="12">
        <el-row type="flex" class="vertical-center-box">
          <el-col class="tit" :span="4">
            수집 서버
          </el-col>
          <el-col :span="20">
            <el-select v-model="logCollectorId" placeholder="해당 없음" @change="changeCollector">
              <el-option :value="null" label="미설정"></el-option>
              <el-option v-for="collector in collectServer" :key="collector.logCollectorId" :value="collector.logCollectorId"
                :label="`${collector.logCollectorName}(${collector.logCollectorIpaddress})`"/>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <!-- 그룹내 기본 설정 로그-->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r15">기본 설정 로그</div>
          <div class="setting-addel mr-r4">
            <el-button size="mini" @click="showAddLogPopup" :disabled="!isExist"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" :disabled="!checkLogFlag" @click="deleteApplog"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
        <div class="vertical-center-box" align="right">
          <el-button :disabled="!checkSelectLog" @click="showLogtreeListPopup" type="primary" size="mini">그룹저장</el-button>
        </div>
      </el-row>
      <!--테이블-->
      <el-row>
          <el-table-wrapper v-loading="loading" :column-default="columnDefault" row-class-name="c-dblclick"  border :data="nodeTableData" :columns="logNodeList" :pagination="false"
            :show-custom-header="false" ref="applogIngroupTable" header-align="center" highlight-current-row @cell-dblclick="showUpdateApplogPopup" @selection-change="checkBoxSelection">
            <template slot-scope="scope" slot="applogType-slot">
              <span v-if="scope.row.applogType === 'T'">텍스트</span>
              <span v-else-if="scope.row.applogType === 'B'">바이너리</span>
              <span v-else>MySql Load</span>
            </template>
            <template slot-scope="scope" slot="patternFlag-slot">
              <span v-if="scope.row.patternFlag === 'N'">고정형</span>
              <span v-else>패턴형</span>
            </template>
            <template slot-scope="scope" slot="logSaveFileFlag-slot">
              <span v-if="scope.row.logInfo.logSaveFileFlag === 'Y'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
            <template slot-scope="scope" slot="retentionAge-slot">
              <span>{{retentionAgeFormat(scope.row.logInfo.retentionAge)}}</span>
            </template>
            <template slot-scope="scope" slot="compressFlag-slot">
              <span v-if="scope.row.logInfo.compressFlag === 'Y'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
            <template slot-scope="scope" slot="applogRawDelInteval-slot">
              <span v-if="scope.row.applogRawDelInteval === 'D'">일간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'W'">주간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'M'">월간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'Y'">연간</span>
              <span v-else>-</span>
            </template>
            <template slot-scope="scope" slot="encryptFlag-slot">
              <span v-if="scope.row.logInfo.encryptFlag === 'Y'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
            <template slot-scope="scope" slot="applogRawDelFlag-slot">
              <span v-if="scope.row.applogRawDelFlag === '1'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
          </el-table-wrapper>
      </el-row>
    </el-row>
    <w-app-log-popup ref="appLogPopup" @addApplogInGroup="addApplogInGroup" :selectPhysicalNode="selectPhysicalNode" :isAdd="isAdd" :settingData="settingData" :selectApplogGroup="params" :logCollectorId="logCollectorId"></w-app-log-popup>
    <w-app-log-tree-list-popup ref="appLogTreeListPopup" :checkList="checkList" :selectPhysicalNode="selectPhysicalNode" :isLogGroup="true"></w-app-log-tree-list-popup>
  </div>
</template>

<script>
import LmsApplogAPI from '@/api/settings/log/lms-applog-setting';
import WTextField from '@/components/formeditor/TextFormEditor';
import { isNil, isEqual, isEmpty, cloneDeep } from 'lodash';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import WAppLogPopup from '../popup/AppLogPopup';
import WAppLogTreeListPopup from '../popup/AppLogTreeListPopup';

export default {
  name: 'WLogFileSetting',
  components: {
    WAppLogPopup,
    WTextField,
    WAppLogTreeListPopup,
  },
  data() {
    return {
      loading: false,
      originCollectorId: null,
      isChange: true,
      isExist: false,
      collectServer: [],
      columnDefault,
      isAdd: true,
      checkGroup: false,
      checkPhysicalNode: false,
      params: {},
      settingData: {},
      nodeTableData: [],
      tableData: [],
      logNodeList: [
        {
          align: 'center',
          headerAlign: 'center',
          type: 'selection',
          width: '50px',
          prop: 'check_flag',
        },
        {
          label: '로그 설정',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'applogId',
              label: '로그아이디',
            },
            {
              prop: 'applogType',
              label: '로그타입',
              scopedSlot: 'applogType-slot',
            },
            {
              prop: 'applogDir',
              label: '로그경로',
            },
            { prop: 'patternFlag',
              label: '타입',
              scopedSlot: 'patternFlag-slot',
            },
            { prop: 'applogFile',
              label: '로그 파일명',
            },
            { prop: 'logSaveFileFlag',
              label: '파일 저장',
              scopedSlot: 'logSaveFileFlag-slot',
            },
            { prop: 'retentionAge',
              label: '파일 보관주기',
              scopedSlot: 'retentionAge-slot',
            },
            {
              prop: 'compressFlag',
              scopedSlot: 'compressFlag-slot',
              label: '압축 여부',
            },
          ],
        },
        {
          label: '원시로그',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'encryptFlag',
              label: '암호화 여부',
              scopedSlot: 'encryptFlag-slot',
            },
            {
              prop: 'applogRawDelFlag',
              label: '삭제 수행',
              scopedSlot: 'applogRawDelFlag-slot',
            },
            {
              prop: 'applogRawDelInteval',
              label: '삭제 주기',
              scopedSlot: 'applogRawDelInteval-slot',
            },
          ],
        },
        { prop: 'orderbyIndex', label: '정렬순서' },
      ],
      checkList: null,
      checkSelectLog: false,
      checkLogFlag: false,
      logCollectorId: null,
      isSetCollector: false,
    };
  },
  props: {
    selectPhysicalNode: {
      type: Object,
    },
  },
  watch: {
    checkList() {
      if (Object.values(this.checkList).length > 0) {
        this.checkSelectLog = true;
      } else {
        this.checkSelectLog = false;
      }
    },
    selectPhysicalNode() {
      if (!isNil(this.selectPhysicalNode) && !isNil(this.selectPhysicalNode.serverId)) {
        this.checkPhysicalNode = true;
        this.showLogListInGroup();
        this.getLogCollector();
      } else {
        this.checkPhysicalNode = false;
        this.checkGroup = false;
        this.tableData = [];
        this.nodeTableData = [];
      }
    },
  },
  mounted() {
    this.getCollectorSever();
  },
  methods: {
    /**
     * 수집기 수정 여부 체크
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeCollector(data) {
      this.isChange = isEqual(data, this.originCollectorId);
    },
    /**
     * 선택한 장치의 수집서버 설정 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    getLogCollector() {
      const params = {
        objId: this.selectPhysicalNode.objId,
      };
      LmsApplogAPI.getServerCollector(params).then((response) => {
        if (response.data.success) {
          if (!isEmpty(response.data.data)) {
            // 데이터가 존재할때
            this.logCollectorId = response.data.data[0].logCollectorId;
            this.originCollectorId = response.data.data[0].logCollectorId;
            this.isChange = true;
            this.isSetCollector = true;
          } else {
            this.logCollectorId = null;
            this.originCollectorId = null;
            this.isSetCollector = false;
          }
          this.isExist = !isNil(this.logCollectorId);
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수집 서버 설정', false));
        throw new Error(e);
      });
    },
    /**
     * 수집 서버 설정 저장
     * @author leesy918
     * @return {[type]} [description]
     */
    saveLogCollector() {
      const params = {
        objId: this.selectPhysicalNode.objId,
        logCollectorId: this.logCollectorId,
      };
      if (this.isExist) {
        LmsApplogAPI.updateServerCollector(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '수집 서버', true));
            this.isChange = true;
            this.getLogCollector();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '수집 서버', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '수집 서버', false));
          throw new Error(e);
        });
      } else {
        LmsApplogAPI.addServerCollector(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '수집 서버', true));
            this.isExist = true;
            this.getLogCollector();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '수집 서버', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '수집 서버', false));
          throw new Error(e);
        });
      }
    },
    /**
     * 수집 서버 설정 취소
     * @author leesy918
     */
    resetLogCollector() {
      this.logCollectorId = cloneDeep(this.originCollectorId);
      this.isChange = true;
    },
    /**
     * 파일 보관 주기 변환
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    retentionAgeFormat(data) {
      if (isNil(data)) {
        return '-';
      }
      return `${data}일`;
    },
    /**
     * 수집 서버 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    getCollectorSever() {
      LmsApplogAPI.getLogCollector().then((response) => {
        if (response.data.success) {
          this.collectServer = response.data.data;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수집 서버', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수집 서버', false));
        throw new Error(e);
      });
    },
    /**
     * 그룹 저장 팝업
     * @author leesy918
     * @return {[type]} [description]
     */
    showLogtreeListPopup() {
      this.$refs.appLogTreeListPopup.open();
    },
    /**
     * 기본설정 로그 체크박스 설정
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    checkBoxSelection(data) {
      this.checkLogFlag = (data.length > 0);
      this.checkList = data;
    },
    /**
     * 기본설정 로그 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteApplog() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        this.loading = true;
        LmsApplogAPI.deleteLmsApplog(this.checkList).then((response) => {
          if (response.data.success) {
            // 응답 데이터 처리
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '로그', true));
            this.getLogListInGroup();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '로그', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '로그', false));
          throw new Error(e);
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },
    /**
     * 로그 추가 팝업 출력
     * @author leesy918
     * @return {[type]} [description]
     */
    showAddLogPopup() {
      this.isAdd = true;
      this.settingData = {
        serverId: this.selectPhysicalNode.serverId,
      };
      this.$refs.appLogPopup.open();
    },
    /**
     * 그룹내 기본설정 로그 조회
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    showLogListInGroup() {
      if (!isNil(this.selectPhysicalNode.serverId)) {
        this.params.serverId = this.selectPhysicalNode.serverId;
        this.params.applogGroupId = 'WatchAll';
        this.params.logCollectorId = this.logCollectorId;
        this.getLogListInGroup();
        this.checkGroup = true;
      } else {
        this.checkGroup = false;
      }
    },
    /**
     * 그룹 내 기본설정 로그 수정
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    showUpdateApplogPopup(row) {
      this.isAdd = false;
      this.settingData = cloneDeep(row);
      this.$refs.appLogPopup.open();
    },
    /**
     * 기본설정 로그 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    getLogListInGroup() {
      this.loading = true;
      LmsApplogAPI.getApplogList(this.params).then((response) => {
        if (response.data.success) {
          this.nodeTableData = [];
          this.$nextTick(() => {
            this.nodeTableData = response.data.data;
          });
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 기본 설정 로그 추가 팝업
     * @author leesy918
     */
    addApplogInGroup() {
      this.showLogListInGroup();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/component/LogFileSetting.vue